import { ExternalLink } from 'lucide-react';
import { ROUTES } from '../../routes/consts';
import { StepConfig } from '../../shared/MultiStepDialog';
import { spawn } from '../../utils/translations';
import { FORM_IDS, STEP_IDS } from './consts';

const spawnSteps = spawn('dialogs.bitbucket-installation.steps');

export const getSteps = (): StepConfig[] => [
  {
    id: STEP_IDS.BEFORE_YOU_BEGIN,
    path: ROUTES.BITBUCKET_INSTALLATION_STEP_1,
    title: spawnSteps('before-you-begin.title'),
    shouldShowBackButton: false,
    shouldShowCancelButton: true,
    isNextInitiallyEnabled: true,
    nextLabel: spawnSteps('before-you-begin.next-label'),
  },
  {
    id: STEP_IDS.CREATE_BOT_USER,
    path: ROUTES.BITBUCKET_INSTALLATION_STEP_2,
    title: spawnSteps('create-bot-user.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: false,
    nextLabel: spawnSteps('create-bot-user.next-label'),
    nextDisabledTooltip: spawnSteps('create-bot-user.next-disabled-tooltip'),
  },
  {
    id: STEP_IDS.GRANT_ACCESS,
    path: ROUTES.BITBUCKET_INSTALLATION_STEP_3,
    title: spawnSteps('grant-access.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: true,
    nextLabel: spawnSteps('grant-access.next-label'),
    nextLabelIcon: ExternalLink,
    formId: FORM_IDS.GRANT_ACCESS,
  },
  {
    id: STEP_IDS.SELECT_REPOSITORIES,
    path: ROUTES.BITBUCKET_INSTALLATION_STEP_4,
    title: spawnSteps('select-repositories.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: false,
    nextLabel: spawnSteps('select-repositories.next-label'),
    formId: FORM_IDS.SELECT_REPOSITORIES,
  },
  {
    id: STEP_IDS.CHECK_CONNECTION,
    path: ROUTES.BITBUCKET_INSTALLATION_STEP_5,
    title: spawnSteps('check-connection.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: true,
    nextButtonVariant: 'outline',
    nextLabel: spawnSteps('check-connection.next-label'),
  },
  {
    id: STEP_IDS.ENABLE_QODO,
    path: ROUTES.BITBUCKET_INSTALLATION_STEP_6,
    title: spawnSteps('enable-qodo.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: true,
    nextLabel: spawnSteps('enable-qodo.next-label'),
  },
];
